import { CSSProperties } from 'react';
import { IconType } from '.';

interface SBLiveWordmarkProps extends IconType {
  style?: CSSProperties;
}

export default function SBLiveWordmark({ color = '#FFFFFF', className = '', height = 16, style, width = 73 }: SBLiveWordmarkProps) {
  return (
    <svg id="sbliveWordmark" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 420 53.91">
      <path
        id="Final_-_Option_1"
        d="M147.9,545.572H129.385l3.318-11.337h.018l2.574-8.793a11.542,11.542,0,0,1,11.124-8.212h51.34l-16.549,17.005H151.219Zm21.313,8.559H139.222l-16.549,17.005h51.34a11.54,11.54,0,0,0,11.124-8.212l2.574-8.793h.018l3.318-11.337H172.532Z"
        transform="translate(-122.673 -517.231)"
        fill="#00bbf2"
      />
      <g id="Group_7091" transform="translate(82.006 0)">
        <g id="Group_7090">
          <path
            id="Path_16809"
            d="M416.455,551.76l-1.66,5.608-1.626,5.558a11.538,11.538,0,0,1-11.126,8.213H347.232l13.4-13.77H396.3l1.842-6.3H367.685a11.381,11.381,0,0,1-11.122-14.458l1.862-5.608,1.423-5.562a11.543,11.543,0,0,1,11.126-8.213h54.811L412.457,531.08l-35.745-.05-1.834,6.271h30.445a11.384,11.384,0,0,1,11.133,14.458Z"
            transform="translate(-347.232 -517.231)"
            fill="#3b3d4e"
          />
          <path
            id="Path_16810"
            d="M603.715,543.461a7.346,7.346,0,0,0,2.55-3.73l2.352-8.033a11.374,11.374,0,0,0-10.81-14.453v-.01h-46.62l-15.777,53.909h56.414a11.542,11.542,0,0,0,11.124-8.212l3.4-11.608a7.276,7.276,0,0,0-2.631-7.864ZM590.3,531.01,588.46,537.3H563.828l1.842-6.294Zm-32.346,26.36,1.842-6.294h28.1l-1.842,6.294Z"
            transform="translate(-466.868 -517.235)"
            fill="#3b3d4e"
          />
          <path
            id="Path_16811"
            d="M781.113,557.37h-28.1l11.747-40.134H746.242l-15.777,53.909h56.411A11.542,11.542,0,0,0,798,562.933l1.628-5.561Z"
            transform="translate(-590.871 -517.234)"
            fill="#3b3d4e"
          />
          <path id="Path_16812" d="M927.291,594.5h15.044l11.974-40.93H939.265Z" transform="translate(-715.931 -540.59)" fill="#3b3d4e" />
          <path
            id="Path_16813"
            d="M1048.477,553.567,1028.022,583.1l-3.181-29.531h-13.955l5.124,40.93h17.358l29.068-40.93Z"
            transform="translate(-769.219 -540.59)"
            fill="#3b3d4e"
          />
          <path
            id="Path_16814"
            d="M1177.06,553.566h-28.1a8.08,8.08,0,0,0-7.787,5.751l-7.206,25.051a7.956,7.956,0,0,0,7.352,10.113v.013h28.587v-.007a8.073,8.073,0,0,0,7.623-5.744l1.3-4.458.332-1.134H1147.6l1.328-4.585h27.208a5.771,5.771,0,0,0,5.562-4.109l3.149-10.766a7.973,7.973,0,0,0-7.787-10.127ZM1151.554,569.5l1.328-4.585h18.3l-1.342,4.585Z"
            transform="translate(-847.149 -540.59)"
            fill="#3b3d4e"
          />
        </g>
      </g>
    </svg>
  );
}
